import { DialogProps, Typography } from '@mui/material';
import { VersionMetadata } from 'api/model';
import InfoDialog from 'components/dialog/InfoDialog';

type VersionDialogProps = DialogProps & {
  onClose: () => void;
  versionMetadata: VersionMetadata;
};

const VersionDialog = ({ open, onClose, versionMetadata }: VersionDialogProps) => {
  return (
    <InfoDialog open={open} buttonsSettings={{ confirmText: 'Close' }} onCancel={onClose} onConfirm={onClose}>
      <div className="flex flex-col">
        <Typography variant="h6" className="mb-4">
          Version Details
        </Typography>
        <div className="grid grid-cols-2 gap-x-4 gap-y-2 items-center">
          {versionMetadata.version && (
            <>
              <Typography variant="body1" className="text-left">
                Version:
              </Typography>
              <strong>{versionMetadata.version}</strong>
            </>
          )}
          <Typography variant="body1" className="text-left">
            Branch:
          </Typography>
          <strong>{versionMetadata.branch}</strong>

          <Typography variant="body1" className="text-left">
            Commit Hash:
          </Typography>
          <strong>{versionMetadata.commit_hash}</strong>

          <Typography variant="body1" className="text-left">
            Build Date:
          </Typography>
          <strong>{versionMetadata.build_date ? new Date(versionMetadata.build_date).toLocaleString() : 'N/A'}</strong>
        </div>
      </div>
    </InfoDialog>
  );
};

export default VersionDialog;
